import { indexCategories } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-cinema-bg">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">专题合集</h2>
          <p className="text-sm text-cinema-muted">按类型探索 · 发现你的下一部好片</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexCategories.map((cat, i) => (
            <a
              key={i}
              href="#ranking"
              className="group flex items-center gap-3 md:gap-4 bg-cinema-card hover:bg-cinema-card-hover border border-cinema-border hover:border-cinema-gold/20 rounded-lg p-4 md:p-5 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-cinema-surface ${cat.color}`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-white group-hover:text-cinema-gold transition-colors whitespace-nowrap">{cat.label}</h3>
                <p className="text-xs text-cinema-muted mt-0.5">{cat.count}部作品</p>
              </div>
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-cinema-muted group-hover:text-cinema-gold transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}